@use '../../../styles/Constants.scss' as Constants;

.total-header {
	font-size: Constants.$val-fontSizeSmall;

	&>span {
		text-transform: uppercase;
	}

	&>b {
		margin-left: Constants.$val-spacing-xs;
		margin-right: Constants.$val-spacing-l;
	}
}